// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class PreviewModalView extends JQueryView {
  isAttachedPitch: boolean;

  constructor(isAttachedPitch: boolean) {
    super('.modal-body');
    this.isAttachedPitch = isAttachedPitch;

    $('.preview-modal').on('shown.bs.modal', () => {
      $('.issue-detail-fields').each((index, item) => {
        $(item).attr('id', `issue-readmore-${index + 5}`);
        $(item)
          .find('.readmore-check')
          .attr('id', `check-${index + 5}`);
        $(item)
          .find('.contents')
          .attr('id', `issue-content-${index + 5}`);
        $(item)
          .find('.readmore-label')
          .attr('for', `check-${index + 5}`);
      });

      const row = 6;
      const lineHeight = 28;
      const fieldHeight = row * lineHeight;

      if ($('#vision-content').height() <= fieldHeight) {
        $('#vision-readmore').removeClass('readmore');
        $('#check1').hide();
      }

      if ($('#introduction-content').height() <= fieldHeight) {
        $('#introduction-readmore').removeClass('readmore');
        $('#check2').hide();
      }

      if ($('#service-content').height() <= fieldHeight) {
        $('#service-readmore').removeClass('readmore');
        $('#check3').hide();
      }

      if ($('#message-content').height() <= fieldHeight) {
        $('#message-readmore').removeClass('readmore');
        $('#check4').hide();
      }

      $('.issue-detail-fields').each(index => {
        if ($(`#issue-content-${index + 5}`).height() <= fieldHeight) {
          $(`#issue-readmore-${index + 5}`).removeClass('readmore');
          $(`#check-${index + 5}`).hide();
        }
      });
    });
  }

  moveToElement(toElement: string) {
    let element = document.getElementById(toElement);
    const headerHeight = 120;
    if (element) {
      $('.modal-body').animate(
        {
          scrollTop:
            element.getBoundingClientRect().top -
            headerHeight +
            $('.modal-body').scrollTop(),
        },
        1000,
      );
    }
  }

  add_class_in_scrolling(target: string) {
    const winScroll = $(window).scrollTop();
    const headerHeight = 140;
    const scrollPos = winScroll + headerHeight;

    if ($(`#${target}-field`).offset().top < scrollPos) {
      $('.modal-nav-link')
        .filter('.active')
        .removeClass('active');
      $(`.${target}-link`).addClass('active');
    }
  }

  fix_header() {
    const fixBranchPoint = 230;
    if (
      !$('.entrepreneur-show-body').hasClass('tab-fixed-show-body') &&
      $('.modal-body').scrollTop() > fixBranchPoint
    ) {
      $('.header-field').addClass('fix-tab');
      $('.entrepreneur-show-body').addClass('tab-fixed-show-body');
    } else if (
      $('.entrepreneur-show-body').hasClass('tab-fixed-show-body') &&
      $('.modal-body').scrollTop() < fixBranchPoint
    ) {
      $('.header-field').removeClass('fix-tab');
      $('.entrepreneur-show-body').removeClass('tab-fixed-show-body');
    }
  }

  @on({ event: 'scroll', selector: 'self' })
  modalScroll() {
    this.fix_header();
    this.add_class_in_scrolling('vision');
    this.add_class_in_scrolling('profile');
    this.add_class_in_scrolling('issue');
    this.add_class_in_scrolling('service');
    if (this.isAttachedPitch) {
      this.add_class_in_scrolling('pitch');
    }
    this.add_class_in_scrolling('message');
    this.add_class_in_scrolling('company');
  }

  @on({ event: 'click', selector: '.vision-link' })
  clickVisionLink(e: any) {
    e.preventDefault();
    this.moveToElement('vision-field');
  }

  @on({ event: 'click', selector: '.profile-link' })
  clickProfileLink(e: any) {
    e.preventDefault();
    this.moveToElement('profile-field');
  }

  @on({ event: 'click', selector: '.issue-link' })
  clickIssueLink(e: any) {
    e.preventDefault();
    this.moveToElement('issue-field');
  }

  @on({ event: 'click', selector: '.service-link' })
  clickServiceLink(e: any) {
    e.preventDefault();
    this.moveToElement('service-field');
  }

  @on({ event: 'click', selector: '.pitch-link' })
  clickPitchLink(e: any) {
    e.preventDefault();
    this.moveToElement('pitch-field');
  }

  @on({ event: 'click', selector: '.message-link' })
  clickMessageLink(e: any) {
    e.preventDefault();
    this.moveToElement('message-field');
  }

  @on({ event: 'click', selector: '.company-link' })
  clickCompanyLink(e: any) {
    e.preventDefault();
    this.moveToElement('company-field');
  }
}
